import React from 'react';
import Dropdown from '../../../../dashboard/common/dropdown/Dropdown';
import '../css/dropdown.scss';
import '../css/style.scss';
import _ from 'lodash';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../css/visitorCheckin.scss';
import HomePageLogo from '../../../../../assets/images/vms/bslogo.png';
import BoyLandscape from '../../../../../assets/images/vms/boy.png';
import GirlLandscape from '../../../../../assets/images/vms/girl.png';

/**
 * Generate an array of hours
 */
const rangeHours = [...Array(10).keys()].map(hour => ({
  id: hour,
  value: hour === 0 ? '1 hour' : `${hour + 1} hours`,
}));

/**
 * Converts Latin-1 Supplement and Latin Extended-A letters to basic Latin letters and removing combining diacritical marks
 * @param {string} str
 * @returns string
 */
const removeAccents = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

/**
 * Show a list of validation errors for given field
 * @param {Array} errors
 * @param {string} fieldName
 * @returns string | null
 */
const renderError = (errors, fieldName) => {
  const messages = errors[fieldName];
  return _.has(errors, fieldName)
    ? _.map(messages, msg => {
        return (
          <li className="ci-error" key={msg.message}>
            {msg.message}
          </li>
        );
      })
    : null;
};

const Page1 = props => {
  const {
    setFieldValue,
    firstName,
    lastName,
    companyName,
    phoneNumber,
    expectedVisitDuration,
    heroFirstName,
    heroLastName,
    errors,
    translations,
    setGoTo,
    config,
  } = props;

  return (
    <>
      <div className="ci-wrap">
        <img className="ci-wrap__boy" src={BoyLandscape} alt="homepage-logo" />
        <img className="ci-wrap__girl" src={GirlLandscape} alt="homepage-logo" />
        <div className="ci-wrap__head">
          <div className="ci-wrap__head-logo">
            <img src={HomePageLogo} alt="homepage-logo" />
          </div>
        </div>
        <div className="ci-wrap__form">
          <div className="ci-wrap__head-title">{_.get(translations, 'checkinTitle')}</div>
          <div className="ci-wrap__head-description">{_.get(translations, 'checkinSubtitle')}</div>
          <div className="ci-form">
            <div className="ci-form__row">
              <label htmlFor="firstName" className="ci-form__row--label">
                {_.get(translations, 'firstName')}
              </label>
              <input
                type="text"
                name="firstName"
                value={firstName}
                className="ci-form__row--input"
                placeholder={_.get(translations, 'enterYourFirstName')}
                maxLength={100}
                autoComplete="new-password"
                onChange={event => setFieldValue({ firstName: event.currentTarget.value })}
              />
              <ul className="ci-error">{renderError(errors, 'firstName')}</ul>
            </div>

            <div className="ci-form__row">
              <label htmlFor="lastName" className="ci-form__row--label">
                {_.get(translations, 'lastName')}
              </label>
              <input
                type="text"
                name="lastName"
                value={lastName}
                className="ci-form__row--input"
                placeholder={_.get(translations, 'enterYourLastName')}
                maxLength={100}
                autoComplete="new-password"
                onChange={event => setFieldValue({ lastName: event.currentTarget.value })}
              />
              <ul className="ci-error">{renderError(errors, 'lastName')}</ul>
            </div>

            <div className="ci-form__row">
              <label htmlFor="companyName" className="ci-form__row--label">
                {_.get(translations, 'companyName')}
              </label>
              <input
                type="text"
                name="companyName"
                value={companyName}
                className="ci-form__row--input"
                placeholder={_.get(translations, 'enterYourCompanyName')}
                maxLength={100}
                autoComplete="new-password"
                onChange={event => setFieldValue({ companyName: event.currentTarget.value })}
              />
              <ul className="ci-error">{renderError(errors, 'companyName')}</ul>
            </div>

            <div className="ci-form__row">
              <label htmlFor="phoneNumber" className="ci-form__row--label">
                {_.get(translations, 'phoneNumber')}
              </label>
              <PhoneInput
                international
                defaultCountry="GB"
                countryCallingCodeEditable={false}
                placeholder={_.get(translations, 'enterYourPhoneNumber')}
                value={phoneNumber}
                onChange={value => setFieldValue({ phoneNumber: value })}
                autoComplete="new-password"
              />
              <ul className="ci-error">{renderError(errors, 'phoneNumber')}</ul>
            </div>

            <div className="ci-form__row">
              <label htmlFor="expectedVisitDuration" className="ci-form__row--label">
                {_.get(translations, 'expectedVisitDuration')}
              </label>
              <div className="ci-form__search">
                <Dropdown
                  onChange={value => setFieldValue({ expectedVisitDuration: value })}
                  options={rangeHours}
                  selectedId={expectedVisitDuration}
                  className="ci-form__row--input"
                  customText=""
                  name="expectedVisitDuration"
                />
              </div>
              <ul className="ci-error">{renderError(errors, 'expectedVisitDuration')}</ul>
            </div>

            <div className="ci-form__row">
              <label htmlFor="heroFirstName" className="ci-form__row--label">
                {_.get(translations, 'heroFirstName')}
              </label>
              <input
                type="text"
                name="heroFirstName"
                value={heroFirstName}
                className="ci-form__row--input"
                placeholder={_.get(translations, 'enterHeroFirstName')}
                maxLength={100}
                autoComplete="new-password"
                onChange={event => setFieldValue({ heroFirstName: removeAccents(event.currentTarget.value) })}
              />
              <ul className="ci-error">{renderError(errors, 'heroFirstName')}</ul>
            </div>

            <div className="ci-form__row">
              <label htmlFor="heroLastName" className="ci-form__row--label">
                {_.get(translations, 'heroLastName')}
              </label>
              <input
                type="text"
                name="heroLastName"
                value={heroLastName}
                className="ci-form__row--input"
                placeholder={_.get(translations, 'enterHeroLastName')}
                maxLength={100}
                autoComplete="new-password"
                onChange={event => setFieldValue({ heroLastName: removeAccents(event.currentTarget.value) })}
              />
              <ul className="ci-error">{renderError(errors, 'heroLastName')}</ul>
            </div>

            <div className="ci-form__buttons">
              <button type="button" className="ci-form__buttons-previous" onClick={() => setGoTo('previous')}>
                {_.get(config, 'page1.btn_prev.text', '')}
              </button>
              <button type="button" className="ci-form__buttons-next" onClick={() => setGoTo('next')}>
                {_.get(config, 'page1.btn_next.text', '')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="ci-footer">{_.get(translations, 'allRightsReserved')}</div>
    </>
  );
};

Page1.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  companyName: PropTypes.string,
  phoneNumber: PropTypes.string,
  expectedVisitDuration: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.any,
  translations: PropTypes.shape({}),
  setFieldValue: PropTypes.func.isRequired,
  setGoTo: PropTypes.func.isRequired,
  config: PropTypes.shape(),
  heroFirstName: PropTypes.string,
  heroLastName: PropTypes.string,
};

Page1.defaultProps = {
  firstName: '',
  lastName: '',
  companyName: '',
  phoneNumber: '',
  errors: [],
  translations: {},
  config: {},
  heroFirstName: '',
  heroLastName: '',
};

export default Page1;
